import { type ReactNode } from 'react';

const TD = 'px-md py-sm';
const PER_PAGE = 20;
const BAR = 'animate-pulse rounded-sm bg-white/[0.05]';

function C({ w, h = 'h-3' }: { w: string; h?: string }): ReactNode {
  return (
    <td className={TD}>
      <div className={`${h} ${w} ${BAR}`} />
    </td>
  );
}

function UserSkel(): ReactNode {
  return (
    <td className={TD}>
      <div className="flex items-center gap-sm">
        <div className={`h-6 w-6 shrink-0 rounded-full ${BAR}`} />
        <div>
          <div className={`h-[13px] w-20 ${BAR}`} />
          <div className={`mt-px h-[11px] w-14 ${BAR}`} />
        </div>
      </div>
    </td>
  );
}

function SkeletonRow(): ReactNode {
  return (
    <tr className="h-[43.9px] border-b border-white/[0.03]">
      <UserSkel />
      <C w="w-10" />
      <C w="w-14" h="h-4" />
      <C w="w-4" />
      <C w="w-16" h="h-4" />
      <C w="w-16" h="h-[11px]" />
      <C w="w-3" />
    </tr>
  );
}

export function TableSkeleton(): ReactNode {
  return (
    <tbody>
      {Array.from({ length: PER_PAGE }, (_, i) => (
        <SkeletonRow key={i} />
      ))}
    </tbody>
  );
}
